import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementEmailTemplate.Save.IRequest;
type Response = Api.Core.StatementEmailTemplate.Save.IResponse;
type Headers = Api.Core.StatementEmailTemplate.Save.IHeaders;
const url = '/api/Management/StatementEmailTemplate';
export default async function statementEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
